(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wrapjkt-editorial-v5"] && !Shopify.designMode) return;
  try {
    document.addEventListener('error',function(event){var image=event.target;if(image instanceof HTMLImageElement&&image.hasAttribute('data-payment-icon')){image.parentElement.hidden=true;}},true);
document.querySelectorAll('[data-payment-icon]').forEach(function(image){if(image.complete&&!image.naturalWidth)image.parentElement.hidden=true;});
  } catch(e) { console.error(e); }
})();

})();
